import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'trattoria_tavolare';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyAaO3DQLFGQAhElalC0xDlF8e0z6GR3uA8',
		authDomain: 'trattoria-f62bc.firebaseapp.com',
		projectId: 'trattoria-f62bc',
		storageBucket: 'trattoria-f62bc.firebasestorage.app',
		messagingSenderId: '284445045480',
		appId: '1:284445045480:web:c56517b659f6ff481c4f5d',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAUJ0yCbuGUs9lDKehj-VGlD0oeU3XO__A',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	allergens_link: '',
	...apiEnvironment,
	hasRecommendations: true,
	hjid: 5035140,
	merchantId: '1110017883',
	merchantGoogleId: '01234567890123456789',
};
